import { createResource } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';

import { getRoutingRules } from '../endpoints';

export const routingRulesResource = createResource({
	type: 'routingRulesResource',
	getKey: () => 'routingRulesResource',
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		assert(
			!!teamId,
			new AssertionError('routingRulesResource', 'teamId should be set to fetch routing-rules'),
		);

		return getRoutingRules(teamId);
	},
	isBrowserOnly: true,
});

export type { RoutingRulesResponse } from '../../common/types';
